/**
 * Local-calendar `YYYY-MM-DD` helpers.
 *
 * Never route these through `toISOString()`: it converts to UTC first, so a date
 * constructed late in the local evening reports the following day.
 */

const YMD = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseYmdLocal(value: string): Date | null {
  if (!value) return null;
  const match = YMD.exec(value.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  // Rejects overflow dates like 2026-02-30, which Date would roll forward.
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
}

export function formatYmd(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
